module.exports = __webpack_public_path__ + "static/media/ordened-asc-icon.4e69dfec.svg";